import numeral from "numeral";

function napformat(data) {
  return numeral(data).format("0,0.00");
}

export default napformat;
